import { DEFAULT_HEADER_HEIGHT, systemWhite } from "../../constants";
import { createStyledElement } from "../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

const isCompactViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 1024 : false;

export const VideoBackground = createStyledElement("div", () => ({
  position: isCompactViewport() ? "relative" : "absolute",
  left: "auto",
  top: isCompactViewport() ? 0 : undefined,
  minHeight: isCompactViewport() ? 420 : undefined,
  height: isCompactViewport()
    ? "clamp(420px, calc(100vh - 68px), 760px)"
    : "calc(100vh - 88px)",
  width: "100%",
  zIndex: -1,
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: systemWhite,
  boxShadow: "inset 0 0 0 1000px rgba(0, 0, 0, 0.32)",
}));

export const MainContent = createStyledElement(
  "div",
  ({ $topOffset }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: isCompactViewport() ? 0 : 80,
    padding: "0 clamp(16px, 6vw, 80px)",
    position: isCompactViewport() ? "absolute" : undefined,
    top: isCompactViewport() ? `${$topOffset}px` : undefined,
    left: isCompactViewport() ? 0 : undefined,
    right: isCompactViewport() ? 0 : undefined,
    width: "100%",
    boxSizing: "border-box",
  }),
  ["$topOffset"]
);

export const VideoSectionContainer = createStyledElement("div", () => ({
  position: "relative",
  height: isCompactViewport() ? "fit-content" : `calc(100vh - ${DEFAULT_HEADER_HEIGHT})`,
  width: "100%",
  marginTop: 48,
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "flex-end",
  padding: 0,
  overflow: "hidden",
}));

export const MainText = createStyledElement("span", () => ({
  font: isCompactViewport()
    ? '700 clamp(18px, 7vw, 42px)/1.25 "Roboto", sans-serif'
    : '700 clamp(42px, 4vw, 48px)/1.25 "Roboto", sans-serif',
  width: "100%",
  maxWidth: isCompactViewport() ? 760 : 700,
  textAlign: "center",
  color: systemWhite,
  textWrap: "balance",
}));

export const CardsContainer = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "center",
  overflow: "hidden",
  width: "100%",
  gap: 20,
  padding: isCompactViewport()
    ? "20px 12px 12px"
    : "0 20px 10px 20px",
  marginTop: isCompactViewport() ? 24 : undefined,
  flexWrap: "wrap",
  position: "relative",
  boxSizing: "border-box",
}));
